import BasicModal from '@/components/UI/Dialog'
import { Box, FormControlLabel, Radio, Typography } from '@mui/material'
import React from 'react'

import { useTranslation } from 'react-i18next'

export default function TurnOnOffDocumentPreviewModal(props: any) {
  const { t } = useTranslation('translation')
  const [documentAllowedHandler, setDocumentAllowedHandler] =
    React.useState(false)
  const changeDocumentAllowedHandler = (e: any) => {
    setDocumentAllowedHandler(e.target.value === 'true' ? true : false)
  }

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      sx={{ width: 430, height: 'auto' }}
      footerActions={[
        { title: t('No'), variant: 'outlined', onClick: props.onHide },
        {
          title: t('Yes'),
          variant: 'contained',
          color: 'error',
          onClick: e => {
            props.confirmHandler(e, {
              selectedRow: props.selectedRow,
              isDocumentTurnOnMode: props.isDocumentTurnOnMode,
              is_full_document_allowed: documentAllowedHandler,
            })
          },
        },
      ]}
    >
      <Box mt={2}>
        <Typography variant="body3">{props.message}</Typography>
        {props.isDocumentTurnOnMode && (
          <div className="mt-3">
            <Typography variant="body1" component="h2">
              {t('Document Preview Access Limit')}
            </Typography>
            <Typography variant="body3">
              {t(
                'Configure the access to the document. A user can see full/a portion of the document based on this setting.',
              )}
            </Typography>
            <FormControlLabel
              control={
                <Radio
                  value="true"
                  checked={documentAllowedHandler}
                  onChange={changeDocumentAllowedHandler}
                />
              }
              label={t('Show full document to the user')}
            />
            <FormControlLabel
              control={
                <Radio
                  value="false"
                  checked={!documentAllowedHandler}
                  onChange={changeDocumentAllowedHandler}
                />
              }
              label={t(
                'Show only a part of the document from where the response was generated',
              )}
            />
          </div>
        )}
      </Box>
    </BasicModal>
  )
}
